"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOverrides = getOverrides;
exports.getToggleStyle = getToggleStyle;
exports.getToggleTrackStyle = getToggleTrackStyle;

var _checkboxStyle = require("./checkboxStyle");

function getToggleStyle(styleArgs) {
  const {
    $theme: theme,
    $checked: checked
  } = styleArgs;
  return {
    height: '18px',
    width: '18px',
    transform: `translateX(${checked ? '20px' : '0'})`,
    // 44 - (18 + 2 * 3)
    backgroundColor: theme.colors.white,
    marginLeft: '3px',
    marginRight: '3px',
    marginTop: '3px',
    marginBottom: '3px'
  };
}

function getToggleTrackStyle(styleArgs) {
  const {
    $theme: theme,
    $checked: checked,
    $disabled: disabled
  } = styleArgs;
  return {
    height: '24px',
    width: '44px',
    backgroundColor: disabled ? theme.colors.grey10 : checked ? theme.colors.primary : theme.colors.grey40,
    transition: 'background-color .25s ease 0s',
    borderTopLeftRadius: '12px',
    borderTopRightRadius: '12px',
    borderBottomRightRadius: '12px',
    borderBottomLeftRadius: '12px',
    marginLeft: 0,
    marginRight: 0,
    marginTop: 0,
    marginBottom: 0
  };
}

function getOverrides(options) {
  return {
    Label: {
      style: styleArgs => (0, _checkboxStyle.getLabelStyle)({ ...styleArgs,
        ...options
      })
    },
    Root: {
      style: styleArgs => (0, _checkboxStyle.getRootStyle)({ ...styleArgs,
        ...options
      })
    },
    Toggle: {
      style: styleArgs => getToggleStyle({ ...styleArgs,
        ...options
      })
    },
    ToggleTrack: {
      style: styleArgs => getToggleTrackStyle({ ...styleArgs,
        ...options
      })
    }
  };
}